var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCimb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 4,
    fill: "#EE3124"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 32.7968H21.9888V17H6V32.7968Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.657 19.9844H8.1604L11.9229 24.8971H20.4202L16.657 19.9844Z",
    fill: "#ED3124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4202 24.8984H11.9229L8.1604 29.8108H16.657L20.4202 24.8984Z",
    fill: "#820024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4786 28.1986H58.4068V25.7636H60.4786C61.445 25.7636 61.7907 26.3895 61.7907 26.9748C61.7907 27.5668 61.445 28.1986 60.4786 28.1986ZM58.4068 21.5988H60.3467C61.1606 21.5988 61.6453 22.023 61.6453 22.7382C61.6453 23.4511 61.1606 23.8749 60.3467 23.8749H58.4068V21.5988ZM62.5323 24.7679C62.997 24.516 63.7593 23.8064 63.7593 22.6507C63.7593 20.8457 62.5131 19.7223 60.5064 19.7223H56.2916V30.0732H60.6838C62.6701 30.0732 63.9051 28.9264 63.9051 27.076C63.9051 25.6859 63.0795 25.041 62.5323 24.7679ZM48.0609 26.3356C47.9814 26.2012 44.3606 19.7019 44.3606 19.7019H42.2918V30.0535H44.4058V23.8697C44.5666 24.1406 48.0609 30.1372 48.0609 30.1372C48.0609 30.1372 51.539 24.1413 51.6942 23.8712V30.0535H53.8104V19.7019H51.7428C51.7428 19.7019 48.1347 26.2012 48.0609 26.3356ZM37.5817 30.0732H39.7033V19.7223H37.5817V30.0732ZM34.0788 27.5798C33.4619 28.0665 32.715 28.3225 31.9279 28.3225C30.0165 28.3225 28.53 26.8193 28.53 24.8989C28.53 22.9782 30.0165 21.4738 31.9279 21.4738C32.715 21.4738 33.4619 21.7302 34.0788 22.2176L34.1082 22.2407L35.5823 20.785L35.5487 20.7542C34.5401 19.8931 33.2566 19.418 31.9279 19.418C28.8354 19.418 26.3196 21.8771 26.3196 24.8989C26.3196 27.9199 28.8354 30.3783 31.9279 30.3783C33.2566 30.3783 34.5401 29.9043 35.5487 29.0433L35.5823 29.0109L34.1082 27.5568L34.0788 27.5798Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCimb);
export default __webpack_public_path__ + "static/media/CIMB.81c40ce07a569164ade62e2180c6dc7c.svg";
export { ForwardRef as ReactComponent };